/* istanbul ignore file */
export const ChallengePromptTitle = {
    AccountPassword: 'Account Password',
    LocalPasscode: 'Application Passcode',
    Biometrics: 'Biometrics',
    RememberFor: 'Remember For',
    Mfa: 'Two-factor Authentication Code',
    U2F: 'Security Key',
};
